// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".calculator-form[data-v-402ce9ac]{padding:var(--spacing-lg) 0}.section-title[data-v-402ce9ac]{font-size:var(--fs-24);font-weight:var(--fw-medium)}.image[data-v-402ce9ac]{display:none}.image img[data-v-402ce9ac]{width:100%}", ""]);
// Exports
module.exports = exports;
